// extracted by mini-css-extract-plugin
export default {"container":"jk-z","blurb":"kk-z","links":"lk-z"};